export default __webpack_public_path__ + "static/media/pieczatka5.b5acc1cd.gif";